<template>
  <nuxt-link
    no-prefetch
    class="nav-btn btn d-flex w-100 rounded-0 px-1 py-1 border-rounded rounded-2"
    :class="{
      'completed-nav-item': completed,
    }"
    :to="!disabled ? item.url : ''"
    :aria-disabled="disabled"
    role="link"
    :aria-current="active ? 'page' : undefined"
  >
    <span class="nav-item align-items-center d-flex"
          :class="{
            'disabled': disabled,
            'nav-item--sub-item': isSubItem
          }">
      <span class="nav-circle d-inline-flex justify-content-center position-relative align-items-center
          align-top rounded-circle"
          :class="{
            'nav-circle--completed': completed,
            'nav-circle--active': active,
            'nav-circle--disabled': !item.visited
          }">
        <font-awesome-icon v-if="completed" :icon="faCheck" class="fa-check fw-bold"></font-awesome-icon>
        <span v-else class="nav-number fw-semibold">
          {{ index + 1 }}
        </span>
      </span>
      <span class="nav-text fw-normal ms-2" :class="{
        'fw-bold': active,
      }">
        {{item.label}}
      </span>
    </span>
  </nuxt-link>
</template>

<script setup>
import { faCheck } from '@fortawesome/pro-regular-svg-icons'

const props = defineProps(['item', 'active', 'index', 'isSubItem', 'completed'])
const emit = defineEmits(['navigate'])

const disabled = computed(() => (!props.item?.visited && !props.active && !props.completed) || !props.item?.url)

</script>

<style lang="scss" scoped>
.nav-btn {
  border-width: 0px; // Fix active buttons always showing a border of 1px solid
}
.nav-btn:focus-visible {
  outline: solid 2px $default-focus-ring-color;
}
.nav-btn:active {
  outline: none;
}
.nav-circle {
  height: 20px;
  aspect-ratio: 1;
  font-size: 12px;

  background: $white;
  color: $type-600;
  border: 1px solid $type-600;
}
.nav-circle--active {
  background: $black;
  color: $neutral-200; // replace with variable
}
.nav-item.disabled {
  color: $neutral-600; // replace with variable
}
.nav-item.disabled .nav-circle {
  color: $neutral-600;
  border-color: $neutral-800; // replace with variable
}
.nav-circle--completed {
  background: $lime-200;
  color: $type-600;
  border-color: $lime-400;
}
.nav-btn:disabled {
  border: none;
  opacity: 1;
}
// .nav-number {
  // Overridden by affiliate-customizations
// }
// .nav-text {
  // Overridden by affiliate-customizations
// }

.nav-item--sub-item {
  font-size: 14px;
  line-height: 16px;

  .nav-circle {
    height: 18px;
    font-size: 10px;
    line-height: 14px;
  }
}

</style>
